<template>
  <div class="form">
    <div class="container">
      <div class="form-container text-left">
        <button @click="$router.go(-1)" class="app-btn px-3 mb-4">
          <v-icon class="mr-3 white-icon" name="arrow-left" scale="1"/> Atrás
        </button>
        <div class="d-flex justify-content-between">
          <span>
            <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
            Fecha de solicitud: {{requestDetail.createdDate | formatDate}}
          </span>
          <div class="d-flex">
            <div class="application-number mr-2">
              Solicitud - <span v-if="requestDetail.conectionType == 'Simple'">UPB</span> <span v-if="requestDetail.conectionType == 'Compleja'">UPM</span>
            </div>
            <div class="application-number">
              #{{requestDetail.id}}
            </div>
          </div>
        </div>
        
        <hr>
        <h4>Datos de la solicitud</h4>
        <div class="input-wrap">
          <label>N&uacute;mero de solicitud: {{requestDetail.id}}</label><br />
          <label>Nombre del proyecto: {{requestDetail.proyectName}}</label><br />

          <label>Documento que se presenta para revisi&oacute;n</label>
          <div class="d-flex align-items-center">
            <div class="radio">
              <input :checked="designData.docRevision == 'estudio'" @click="designData.docRevision = 'estudio'" id="radio-docrev-type-1" name="radio-doc-revision" type="radio">
              <label for="radio-docrev-type-1" class="radio-label">Estudio</label>
            </div>
            <div class="radio">
              <input :checked="designData.docRevision == 'diseno'" @click="designData.docRevision = 'diseno'" id="radio-docrev-type-2" name="radio-doc-revision" type="radio">
              <label for="radio-docrev-type-2" class="radio-label">Diseño</label>
            </div>
          </div>

          <hr>
          <h4>Información del propietario e ingeniero diseñador</h4>
          <div class="row">
            <div class="col">
              <label for="nombreConstructura">Nombre constructora</label>
              <input type="text" id="nombreConstructura" v-model="designData.nombreConstructura">
            </div>
            <div class="col">
              <label for="nitConstructura">NIT</label>
              <input type="text" maxlength="15" id="nitConstructura" v-model="designData.nitConstructura">
            </div>
          </div>

          
          <h5>Ingeniero responsable</h5>
          <label for="nameRazon">Nombre o razón social</label>
          <input type="text" id="nameRazon" v-model="designData.nameRazon">
          <label>Tipo de documento</label>
          <div class="d-flex align-items-center">
            <div class="radio">
              <input :checked="designData.documentType == 'CC'" @click="designData.documentType = 'CC'" id="radio-doc-type-1" name="radio-doc-type" type="radio">
              <label for="radio-doc-type-1" class="radio-label">Cédula de ciudadanía</label>
            </div>
            <div class="radio">
              <input :checked="designData.documentType == 'CE'" @click="designData.documentType = 'CE'" id="radio-doc-type-2" name="radio-doc-type" type="radio">
              <label for="radio-doc-type-2" class="radio-label">Cédula de extranjería</label>
            </div>
            <div class="radio">
              <input :checked="designData.documentType == 'Nit'" @click="designData.documentType = 'Nit'" id="radio-doc-type-3" name="radio-doc-type" type="radio">
              <label for="radio-doc-type-3" class="radio-label">Nit</label>
            </div>
          </div>
          <div class="mb-4">
            <label for="ingName">Nombre del ingeniero / diseñador</label>
            <input type="text" id="ingName" v-model="designData.ingName">
          </div>
          <div class="row">
            <div class="col">
              <label for="documentNumber">Número de documento</label>
              <input type="text" @keypress="onlyNumber" id="documentNumber" v-model="designData.documentNumber">
            </div>
            <div class="col">
              <label for="celPhoneNumber">Celular</label>
              <input type="text" @keypress="onlyNumber" maxlength="10" id="celPhoneNumber" v-model="designData.celPhoneNumber">
            </div>
            <div class="col">
              <label for="email">Correo</label>
              <input type="text" id="email" v-model="designData.email">
            </div>
            <div class="col">
              <label for="profesionalEnrollment">Matrícula profesional</label>
              <input type="text" id="profesionalEnrollment" v-model="designData.profesionalEnrollment">
            </div>
          </div>
          <div class="my-3">
            <h5 class="mb-0">Dirección diseñador</h5>
            <div class="row mb-2">
              <div class="col">
                <label for="name">Tipo de via</label>
                <select name="via-type" id="via-type-1" v-model="designData.address.streetType">
                  <option value="Calle">Calle</option>
                  <option value="Carrera">Carrera</option>
                  <option value="Avenida">Avenida</option>
                  <option value="Autopista">Autopista</option>
                  <option value="Diagonal">Diagonal</option>
                  <option value="Transversal">Transversal</option>
                </select>
              </div>
            
              <div class="col">
                <label for="name">Via principal</label>
                <div class="row no-gutters">
                  <div class="col pr-2">
                    <input type="text" id="name" v-model="designData.address.road1">
                  </div>
                  <div class="col">
                    <select name="street-type" id="via-type-1" v-model="designData.address.road1Direction">
                      <option value="Norte">Norte</option>
                      <option value="Oeste">Oeste</option>
                      <option value="Bis">Bis</option>
                      <option value="Ninguna">Ninguna</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="direction-separator">
                  #
                </div>                
                <label for="name">Via secundaria</label>
                <div class="row no-gutters">
                  <div class="col pr-2">
                    <input type="text" id="name" v-model="designData.address.road2">
                  </div>
                  <div class="col">
                    <select name="street-type" id="via-type-1" v-model="designData.address.road2Direction">
                      <option value="Norte">Norte</option>
                      <option value="Oeste">Oeste</option>
                      <option value="Bis">Bis</option>
                      <option value="Ninguna">Ninguna</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="direction-separator">
                  -
                </div>
                <label for="streetNumber">Número</label>
                <input type="text" id="streetNumber" v-model="designData.address.streetNumber">
              </div>
            </div>

          </div>
          <div class="row mb-4">
            <div class="col">
              <label for="name">Número interior/piso (Bloque, Torre, Apartamento, Casa #)</label>
              <input type="text" id="name" v-model="designData.address.description">
            </div>
            <div class="col">
              <label for="municipality">Municipio</label>
              <input type="text" id="municipality" v-model="designData.municipality">
            </div>
          </div>

          <hr>
          <div class="my-3">
            <h5 class="mb-0">Propietario o representante legal</h5>
            <label for="nombreRepreLegal">Nombre representante legal</label>
            <input type="text" id="nombreRepreLegal" v-model="designData.nombreRepreLegal">

            <div class="row">
              <div class="col">
                <label for="documentRepreLegal">C&eacute;dula de ciudadan&iacute;a</label>
                <input type="text" @keypress="onlyNumber" id="documentRepreLegal" v-model="designData.documentRepreLegal">
              </div>
              <div class="col">
                <label for="celPhoneRepreLegal">Tel&eacute;fono de contacto</label>
                <input type="text" @keypress="onlyNumber" maxlength="10" id="celPhoneRepreLegal" v-model="designData.celPhoneRepreLegal">
              </div>
              <div class="col">
                <label for="emailRepreLegal">Correo electr&oacute;nico</label>
                <input type="text" id="emailRepreLegal" v-model="designData.emailRepreLegal">
              </div>
            </div>
          </div>


          <div class="mb-3">
            <label>¿Autoriza la notificación mediante correo electrónico?</label>
            <div class="d-flex align-items-center">
              <div class="radio">
                <input :checked="designData.notificationsAuth == 1" @click="designData.notificationsAuth = 1" id="mailnotifications1si" name="mailnotifications1" type="radio">
                <label for="mailnotifications1si" class="radio-label">Si</label>
              </div>
              <div class="radio">
                <input :checked="designData.notificationsAuth == 0" @click="designData.notificationsAuth = 0" id="mailnotifications1no" name="mailnotifications1" type="radio">
                <label for="mailnotifications1no" class="radio-label">No</label>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-12">
              <label for="observaciones">Observaciones adicionales</label>
              <textarea id="observaciones" cols="20" rows="10" v-model="designData.observaciones"></textarea>
            </div>
          </div>

          <hr>
          <div>
            <h4>Información del proyecto </h4>
            <p>A ccc continuación debes subir todos los archivos necesarios para continuar con el proceso,
              puedes ver la guía de docuementos requeridos en el siguiente link.</p>
            <a class="mb-3 app-btn app-btn--blue px-3" download href="/files/GUIAv2.pdf">Ver guía de documentos requeridos</a>
            
            <div  class="alert alert-info">
              <h5>Documentos anexos</h5>
              <div v-for="(item, index) in arrayLoadedDocuments" lass="mb-2 d-flex" style="font-size:0.8rem">
                <strong>{{item.id}}. </strong>
                <a :href="item.anexo" title="Descargar documento" target="_blank"><strong>{{item.name}}</strong></a> - {{ item.description }} - {{ item.createdDate  | formatDate }}
                <button type="button" class="close" @click="confirmedDoc = true; indice = index; validarInputDocument()">
                    
                </button>
              </div> 
              <hr />
              <div v-for="(item, index) in arrayDocuments" :key="index" lass="mb-2 d-flex" style="font-size:0.8rem">
                <strong>{{item.docItemId}}. {{item.docItemName}}: </strong>&nbsp;&nbsp;{{item.description}} - 
                <button type="button" class="close" @click="confirmedDoc = true; indice = index; validarInputDocument()" >
                    <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                </button>
              </div> 
            </div>
            
            <div class="row">  
            <div class="col-md-6" v-for="(item, index) in arrayDocsItems" :key="index"> 
              <label class="file" style="font-size:0.8rem" :id="'file' + item.id" >{{item.id}}. {{item.name}} 
                <span v-if="item.required == 'S' && !uploadedDocument(item.id)" style="color:red">(Obligatorio)</span>&nbsp;
                <v-icon  name="upload" scale="1.0"/>
                  
                  <input @change="onFileChangeDocument($event, item)" type="file"> 
              </label>
            </div>  
          </div>
          
          </div>
          <div>
            <button @click="confirmedInfo = true; validarInputInfo()" class="app-btn app-btn--green w-100">
              Enviar Información
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="confirmedDoc == false" class="error-modal">
      <div @click="confirmAcceptDoc = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de borrar el documento?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAcceptDoc = true; confirmedDoc = true; borrarDocumento(indice)" class="app-btn app-btn">ACEPTAR</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAcceptDoc = false; confirmedDoc = true" class="app-btn app-btn--blue">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="confirmedInfo == false" class="error-modal">
      <div @click="confirmAcceptInfo = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de enviar la información?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAcceptInfo = true; confirmedInfo = true; sendRequest()" class="app-btn app-btn">ACEPTAR</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAcceptInfo = false; confirmedInfo = true" class="app-btn app-btn--blue">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div v-if="error != ''" class="error-modal">
      <div @click="error = ''" class="backdrop"></div>
      <div class="modal-box">
        <div class="app-icon mb-2"> 
          <v-icon name="exclamation-triangle" scale="2"/>
        </div>
        <div class="mb-4"  v-html="error" style="text-align: left; font-size: 1.1rem;">
          
        </div>
        <div>
          <button @click="error = ''" class="app-btn w-100">Continuar</button>
        </div>
      </div>
    </div>

    <!-- Screen Loader -->
    <div v-if="loading" class="screen-loader">
      <div class="spinner">
        <v-icon name="circle-notch" scale="3"/>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';
import axios from "axios";

export default {
  name: 'DesignDataForm',
  components: {
    
  },
  data(){
    return {
      date: new Date(),
      options: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      document: '',
      documentFile: '',
      confirmedDoc: true,
      confirmAcceptDoc: false,
      confirmAcceptInfo: false,
      confirmedInfo: true,
      arrayLoadedDocuments: [], //Documentos que ya se han cargado a la solicitud con anteriordad
      arrayDocuments: [], //Documentos que se han seleccionado
      arrayDocsItems: [], //Informacion de documentos que se deben cargar en el formulario
      designData: {
        nameRazon: '',
        documentType: '',
        ingName: '',
        documentNumber: '',
        celPhoneNumber: '',
        email: '',
        municipality: '',
        profesionalEnrollment: '',
        notificationsAuth: 1,
        docRevision: '',
        nombreConstructura: '',
        nitConstructura: '',
        nombreRepreLegal: '',
        documentRepreLegal: 0,
        celPhoneRepreLegal: 0,
        emailRepreLegal: '',
        observaciones: '',
        address: {
          streetType: '',
          road1: '',
          road1Direction: '',
          road2: '',
          road2Direction: '',
          streetNumber: '',
          description: ''
        },
      },
      loading: false,
      error: ''
    }
  },
  mounted(){
    window.onbeforeunload = function(){
      return '¿Estas seguro? Esto eliminará la información';
    };

    this.getUserDesignData();
    this.getUserDesignDocumentsItems();
    
  },
  methods:{
    borrarDocumento(indice){
      this.arrayDocuments.splice(indice,1);     
    },
    validarInputDocument(){
      this.confirmedDoc = false;
        return;        
    },
    validarInputInfo(){
      this.confirmedInfo = false;
        return;        
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault();
      }
    },    
    getUserDesignData(){
      axios.get("/designData/request/" + this.requestDetail.id)
        //axios.get("/designData/request/1")
        .then(response => {
          if (response.data.length != 0) {

            this.designData = response.data[response.data.length - 1];
            this.designData.forEach(element => {
              element.titleHeader = "Información de diseño";
              element.state = "Approved";
              element.documents = [];
            });
          }
        });

      this.getUserDesignLoadedDocuments();
    },
    getUserDesignDocumentsItems(){
      axios.get("/desingDocumentItem/findAll")
        .then(response => {
          if (response.data.length != 0) {
            this.arrayDocsItems = response.data;
          }
      })
    },
    sendRequest() {
      var cargado = false;
      var errores = '';
      for (let i = 0; i < this.arrayDocsItems.length; i++) {
        if (this.arrayDocsItems[i].required == 'S' && !this.uploadedDocument(this.arrayDocsItems[i].id)) {
          cargado = false;
          for (let j = 0; j < this.arrayDocuments.length; j++) {
            if (this.arrayDocsItems[i].id == this.arrayDocuments[j].docItemId) {
              cargado = true;
            }
          }

          console.log('cargado', cargado);
          if (!cargado) { 
            errores += '<li>' + this.arrayDocsItems[i].id + '. ' + this.arrayDocsItems[i].name + '</li>';
          }
        }
      }

      console.log('errores', errores);
      if (errores != '') {
        this.error = 'Advertencia. Los siguientes documentos son obligatorios <p><ul>' + errores + '</ul></p>';
        return;  
      }

      if (this.designData.nameRazon == '') {
        this.error = 'Debes agregar el nombre o razón social de la empresa';
        return;
      }

      if (this.designData.documentType == '') {
        this.error = 'Selecciona el tipo de documento';
        return;
      }

      if (this.designData.ingName == '') {
        this.error = 'Debes agregar el nombre del ingeniero / diseñador';
        return;
      }

      if (this.designData.documentNumber == '') {
        this.error = 'Debes agregar el número de documento';
        return;
      }

      if (this.designData.celPhoneNumber == '') {
        this.error = 'Debes agregar el número de celular';
        return;
      }

      if (this.designData.email == '') {
        this.error = 'Debes agregar el email';
        return;
      }

      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.designData.email)) {
          // Good email
      } else {
          this.error = 'Escriba un email válido';
          return;
      }

      if (this.designData.municipality == '') {
        this.error = 'Debes agregar el municipio';
        return;
      }

      if (this.designData.profesionalEnrollment == '') {
        this.error = 'Debes agregar el número de matricula profesional. si no tiene agrega "0"';
        return;
      }

      if (this.designData.address.streetType == '') {
        this.error = 'Seleccione el tipo de vía de la dirección';
        return;
      }
      if (this.designData.address.road1 == '') {
        this.error = 'Digite la vía principal de la dirección';
        return;
      }
      if (this.designData.address.road1Direction == '') {
        this.error = 'Seleccione la orientación de la vía principal';
        return;
      }
      if (this.designData.address.road2 == '') {
        this.error = 'Digite la vía secundaria de la dirección';
        return;
      }
      if (this.designData.address.road2Direction == '') {
        this.error = 'Seleccione la orientación de la vía secundaria';
        return;
      }
      if (this.designData.address.streetNumber == '') {
        this.error = 'Digite el número de la calle';
        return;
      }
      
      /*if (this.designData.address.description == '') {
        this.error = 'Proporcione una indicación extra de la dirección o la dirección como la conoces';
        return;
      }*/

      if (this.arrayDocuments.length == 0) {
        this.error = 'Debes agregar los documentos de diseño requeridos para continuar.';
        return;
      }

      this.loading = true;

      let dataSendAddress = {
        "description": this.designData.address.description,
        "road1": this.designData.address.road1,
        "road1Direction": this.designData.address.road1Direction,
        "road2": this.designData.address.road2,
        "road2Direction": this.designData.address.road2Direction,
        "streetNumber": this.designData.address.streetNumber,
        "streetType": this.designData.address.streetType,
        "createdDate": new Date(),
        "editedDate": new Date()
      };

      axios.post("address/add", dataSendAddress, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json' 
        }
      })
      .then((resultApplicantAddress) => {

        let designData = {
          "nameRazon": this.designData.nameRazon,
          "documentType": this.designData.documentType,
          "ingName": this.designData.ingName,
          "documentNumber": this.designData.documentNumber,
          "celPhoneNumber": this.designData.celPhoneNumber,
          "email": this.designData.email,
          "municipality": this.designData.municipality,
          "profesionalEnrollment": this.designData.profesionalEnrollment,
          "notificationsAuth": this.designData.notificationsAuth,
          "idAddress":resultApplicantAddress.data,
          "idRequest": this.requestDetail.id,
          "updateDate":new Date(),
          "createDate": new Date(),
          
          "docRevision": this.designData.docRevision,
          "nombreConstructura": this.designData.nombreConstructura,
          "nitConstructura": this.designData.nitConstructura,
          "nombreRepreLegal": this.designData.nombreRepreLegal,
          "documentRepreLegal": this.designData.documentRepreLegal,
          "celPhoneRepreLegal": this.designData.celPhoneRepreLegal,
          "emailRepreLegal": this.designData.emailRepreLegal,
          "observaciones": this.designData.observaciones
        }

        axios.post("designData/add", designData, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then((result) => {
          
          for (let i = 0; i < this.arrayDocuments.length; i++) {
            this.arrayDocuments[i].idDesignData = result.data.id;
          }
          
          this.sendDesignDocumentRequest(0);
        })
        .catch((e) => {
          this.loading = false;
          this.error = 'Se produjo un error al enviar los diseños, por favor intentelo de nuevo más tarde.';
        })

      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se produjo un error al enviar los diseños, por favor intentelo de nuevo más tarde.';
      })

    },
    sendDesignDocumentRequest(index){

      let newObjectDesignDocument = {
        "anexo": this.arrayDocuments[index].anexo,
        "description": this.arrayDocuments[index].description,
        "idDesignData": this.arrayDocuments[index].idDesignData,
        "desingDocumentItem": {
          "id": this.arrayDocuments[index].docItemId,
          "name": this.arrayDocuments[index].docItemName
        },
        "status": 'Activo',
        "editedDate": new Date(),
        "createdDate": new Date()
      };

      axios.post("desingDocument/add/" + this.requestDetail.id, newObjectDesignDocument, {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json'
        }
      }).then((result) => {
        if (index < this.arrayDocuments.length - 1) {
          this.sendDesignDocumentRequest(index + 1);
        }else{
          this.loading = false;
          this.$router.push('requestDetail');
          return;
        }

      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
        return;
      })

    },
    onFileChangeDocument(event, docItem){
      let files = event.target.files[0];
      //console.log(event);
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        let newDesignDocument = {
          "anexo": reader.result,
          "description": files.name,
          "docItemName": docItem.name,
          "docItemId": docItem.id,
          "idDesignData": 1,
          "status": 'Activo'
        };

        this.arrayDocuments.push(newDesignDocument);  
        const element = document.getElementById('file' + docItem.id);
        element.style = 'background-color: #d1ecf1; font-size: 0.8rem;';

      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },
    getUserDesignLoadedDocuments(){
      this.arrayLoadedDocuments = [];

      axios.get("/designData/request/" + this.requestDetail.id)
        .then(response => {
          if (response.data.length != 0) {
            let approved = response.data;
            approved.forEach(element => {
              element.documents = [];

              //@TODO
              //this.requestHistory.push(element);

              axios.get("/desingDocument/designData/" + element.id)
                .then(response => {

                  if (response.data.length != 0) {

                    let documents = response.data;
                    documents.forEach(el => {
                      this.arrayLoadedDocuments.push({
                        id: el.desingDocumentItem.id,
                        anexo: el.anexo,
                        createdDate: el.createdDate,
                        name: el.desingDocumentItem.name,
                        description: el.description,
                      });
                    });
                  }
                })
            });
          }
        });

      console.log('arrayLoadedDocuments', this.arrayLoadedDocuments);
    },
    uploadedDocument(itemId) {
      let loaded = false;
      for (let i = 0; i < this.arrayLoadedDocuments.length; i++) {
        if (itemId == this.arrayLoadedDocuments[i].id) {
          loaded = true;
        }
      }

      return loaded;
    },
    getHrefAnexo(itemId) {
      let href = '#';
      for (let i = 0; i < this.arrayLoadedDocuments.length; i++) {
        if (itemId == this.arrayLoadedDocuments[i].id) {
          href = this.arrayLoadedDocuments[i].anexo;
        }
      }

      return href;
    },
    getCreatedDate(itemId) {
      let createdDate = '';
      console.log(this.arrayLoadedDocuments);
      for (let i = 0; i < this.arrayLoadedDocuments.length; i++) {
        if (itemId == this.arrayLoadedDocuments[i].id) {
          createdDate = this.arrayLoadedDocuments[i].createdDate;
        }
      }

      return createdDate;
    }
  },
  computed: {
    ...mapState({
      requestDetail: state => state.requestDetail
    })
  }
}
</script>

<style lang="scss">
.form {
  padding: 50px 0;  
}
</style>
